import { render, staticRenderFns } from "./pickup-item.vue?vue&type=template&id=3c7c2a77&scoped=true&"
import script from "./pickup-item.vue?vue&type=script&lang=js&"
export * from "./pickup-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7c2a77",
  null
  
)

export default component.exports